import { Component, Input, OnInit } from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import {MatTableDataSource, MatTableModule} from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { convertCurrency } from '../../../shared/utils/utils'
import { MatDialog } from '@angular/material/dialog'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListTariffComponent } from '../../../shared/components/table-list-tariff/table-list-tariff.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import { ExamRelationPatientFormEditComponent } from './exam-relation-patient-form-edit/exam-relation-patient-form-edit.component'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import {ErrorRequestModel, ResponseRequestModel} from '../../../core/models/response.model';
import {SnackbarCustomService} from '../../../shared/components/snackbar/snackbar-custom.service';
import {
  MonitoringService
} from '../../../core/services/monitoring/legal-entity-client/monitoring.service';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'exam-patient-edit',
  imports: [
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBar,
    TableListTariffComponent,
    MatButton,
    MatIcon,
    MatSelectModule,
    MatFormFieldModule,
  ],
  templateUrl: './exam-relation-patient-edit.component.html',
  styleUrl: './exam-relation-patient-edit.component.scss',
  providers: [AddressTypeService],
  standalone: true,
})
export class ExamRelationPatientEditComponent implements OnInit {
  constructor(
    private tariffService: TariffService,
    private authService: AuthService,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,
    private monitoringService: MonitoringService
  ) {}

  @Input() idPatient: number = 0

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  selectedStatus: number | null = 1 // Padrão: Ativo (1)

  statusOptions = [
    { value: 0, label: 'Todos' },
    { value: 1, label: 'Ativo' },
    { value: 4, label: 'Inativo' }
  ]

  columns: any[] = [
    {
      keyColumn: 'subtipoExame',
      key: 'subtipoexame',
      description: 'Exame',
    },
    {
      keyColumn: 'descricao',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = [
    'subtipoExame',
    'descricao',
    'action',
  ]

  screen: string = 'tarifário'

  ngOnInit() {
    // this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  onStatusChange(status: number | null) {
    this.selectedStatus = status
    this.page = 1
    this.uploadList()
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        // custo	125.50JS:125.5
        list.push({...item, model_serial: `${item.modelo} - ${item.numero_serial}`})
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    // Adiciona o parâmetro de status apenas se não for null (Todos)
    const params = this.selectedStatus !== 0 ? { status: this.selectedStatus } : {}

    this.tariffService
      .listReminderByIdPaciente(this.idPatient, params)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.tariffService
      .searchPagedTariff(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  newItem() {
    const dialogRef = this.dialog.open(ExamRelationPatientFormEditComponent, {
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { edit: false, idClient: this.idPatient },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ExamRelationPatientFormEditComponent, {
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: {edit: true, item: item, idClient: this.idPatient}
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
    this.FinishMonitoring(item)
  }

  FinishMonitoring(item: any){
    const model = {id_paciente: this.idPatient, id_exame: item.id}
    this.monitoringService.finishMonitoring(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.getListItems()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
}
